import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { User, FilesService } from './GI.Web.Services.g';

/** Gets and caches the current user */
@Injectable()
export class CurrentUserService {

  constructor(private _filesService: FilesService) { }

  private _user: User;
  private _getUserRequest: Observable<User>;

  public getUser(): Observable<User> {

    // let testUser:any;
    // testUser = new Object()
    // testUser.betaUser = true;
    // testUser.isArchiveUser = true;
    // testUser.isAdmin = true;
    // return Observable.from([testUser]);

    if (this._user == null) {
      if (this._getUserRequest == null) {
        const setFreshdeskProperties = true;
        this._getUserRequest = this._filesService.getUser(setFreshdeskProperties).share();
      }
      this._getUserRequest.subscribe(r => {
        this._user = r;
      });
      return this._getUserRequest.map(r => r);
    } else {

      return Observable.from([this._user]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/current-user.service.ts